(function() {
	'use strict';
	var $ = avm.require('jquery'),
		browser = avastGlobals.detect.browser;

			if (browser.isChrome) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="chrome"]').css('display', 'block');
			}
			if (browser.isAvast) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="secure-browser"]').css('display', 'block');
			}
			if (browser.isFirefox) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="firefox"]').css('display', 'block');
			}
			if (browser.isOpera) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="opera"]').css('display', 'block');
			}
			if (browser.isSafari) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="chrome"]').css('display', 'block');
			}
			if (browser.isEdge || browser.isInternetExplorer || browser.isEdgeChromium) {
				$('[data-brwsr]').css('display', 'none');
				$('[data-brwsr="ie"]').css('display', 'block');
			}
})();
